import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit';

import { IProduct } from 'interfaces/products';
import { getPartnerDataById } from 'services/products';
import { RootState } from 'store';

interface ProductsState {
	activeProduct: IProduct | null;
};

const initialState: ProductsState = {
	activeProduct: null,
};

export const fetchProduct = createAsyncThunk(
	'products/fetchProduct',
	async (productId: string) => {
		const { data: productData } = await getPartnerDataById(productId);
		return { productData };
	}
);

export const productsSlice = createSlice({
	name: 'products',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchProduct.fulfilled, (state, action) => {
				state.activeProduct = action.payload.productData;
			})
			.addCase(fetchProduct.rejected, (state) => {
				state.activeProduct = null;
			})
	},
});

export const selectActiveProduct = (state: RootState) => state.products.activeProduct;
export const selectActiveProductSlug = createSelector(
	selectActiveProduct,
	(activeProduct) => activeProduct?.slug || ''
);
export const selectActiveProductOffer = createSelector(
	selectActiveProduct,
	(activeProduct) => (activeProduct?.products || [])[0] || { asrBalanceDictID: null, offerId: null }
);

export default productsSlice.reducer;
